import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import VariableValueForm from "../types/VariableValueForm";

export const CouponDaysExpForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "number",
    mask: "999",
    prefix: "",
    suffix: " dias",
    placeholder: "--- dias",
    min: 1,
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CouponDaysExp}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <VariableValueForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
